<body>
  <div class="grid-overlay">
    <div class="header">
      <div class="logo">
        <a routerLink="/my-portals">
          <img src="../../assets/images/BRAND2.png" alt="logo de Billcentrix">
        </a>
      </div>
      <div class="buttons">
        <img src="../../assets/icons/reportes_aqua.png" alt="icono usuarios">
        <app-menu></app-menu>
      </div>
    </div>

    <div class="reports-data">
      <div>
        <h1>{{ 'onboardingUsers.title' | translate }}</h1>
      </div>
      <mat-accordion>
        <mat-expansion-panel [expanded]="isOpenSearchPanel" (opened)="openSearchPanel(true)" [hideToggle]="true">
          <mat-expansion-panel-header>
            <button class="btn-icon btn" title="{{ 'onboardingUsers.search.title' | translate }}" type="button">
              <i class="material-icons">search</i>
            </button>
          </mat-expansion-panel-header>

          <form>
            <fieldset class="fieldset">
              <div fxLayout="row wrap" class="fild_search">
                <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                  <div class="pb-16">
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'onboardingUsers.search.name' | translate }}</mat-label>
                      <input
                        matInput
                        name="name_user"
                        maxlength="120"
                        [(ngModel)]="filter.name_user">
                      </mat-form-field>
                    </div>
                  </div>

                  <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                    <div class="pb-16">
                      <mat-form-field class="full-width">
                        <mat-label>{{ 'onboardingUsers.search.lastName' | translate }}</mat-label>
                        <input
                          matInput
                          name="lastName_user"
                          maxlength="120"
                          [(ngModel)]="filter.lastName_user">
                        </mat-form-field>
                      </div>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                      <div class="pb-16">
                        <mat-form-field class="full-width">
                          <mat-label>{{ 'onboardingUsers.search.email' | translate }}</mat-label>
                          <input
                            matInput
                            name="email_user"
                            maxlength="120"
                            [(ngModel)]="filter.email_user">
                          </mat-form-field>
                        </div>
                      </div>

                      <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                        <div class="pb-16">
                          <mat-form-field appearance="fill">
                            <mat-label>{{ 'onboardingUsers.search.status' | translate }}</mat-label>
                            <mat-select [(value)]="filter.status_user">
                              <mat-option [value]="undefined">{{ 'onboardingUsers.search.all' | translate }}</mat-option>
                              @for (status of statusOptions; track status) {
                                <mat-option [value]="status.value">
                                  {{ status.label }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <div class="button_report_align" fxLayout="row" fxLayoutAlign="end center">
                    <button
                      mat-raised-button
                      type="button"
                      color="warn"
                      class="ml-16 mr-16 button_report light"
                      (click)="reset()">
                      <mat-icon>refresh</mat-icon>
                    </button>

                    <button
                      mat-raised-button
                      type="button"
                      color="primary"
                      class="ml-16 button_report blue"
                      (click)="search()">
                      <mat-icon>search</mat-icon>
                    </button>
                  </div>
                </form>
              </mat-expansion-panel>
            </mat-accordion>

            <div style="padding-top: 2em;">
              <div style="margin-bottom: 1rem; text-align: right;">
                <button mat-raised-button color="primary" (click)="create()">
                  <mat-icon>add</mat-icon> {{ 'onboardingUsers.createButton' | translate }}
                </button>
              </div>

              <mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="name_user">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'onboardingUsers.table.columns.name' | translate }} </mat-header-cell>
                  <mat-cell *matCellDef="let row" data-label="name_user"> {{row.name_user}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="lastName_user">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'onboardingUsers.table.columns.lastName' | translate }} </mat-header-cell>
                  <mat-cell *matCellDef="let row" data-label="lastName_user"> {{row.lastName_user}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="email_user">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'onboardingUsers.table.columns.email' | translate }} </mat-header-cell>
                  <mat-cell *matCellDef="let row" data-label="email_user"> {{row.email_user}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="status_user">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'onboardingUsers.table.columns.status' | translate }} </mat-header-cell>
                  <mat-cell *matCellDef="let row" data-label="status_user">
                    {{getStatusLabel(row.status_user)}}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'onboardingUsers.table.columns.actions' | translate }} </mat-header-cell>
                  <mat-cell *matCellDef="let row" data-label="acciones">
                    <button mat-icon-button [matMenuTriggerFor]="msgMenu" (click)="$event.stopPropagation()" class="hidden-on-open">
                      <mat-icon class="text-muted">more_vert</mat-icon>
                    </button>
                    <mat-menu style="width: 250px;" #msgMenu="matMenu">
                      <button mat-menu-item (click)="update(row)" class="menu_report"><mat-icon style="color: white;">edit</mat-icon> {{ 'onboardingUsers.table.menu.edit' | translate }}</button>
                      <button mat-menu-item (click)="resendInvitation(row)" class="menu_report"><mat-icon style="color: white;">send</mat-icon> {{ 'onboardingUsers.table.menu.resendInvitation' | translate }}</button>
                      @if (row.status_user === 1) {
                        <button mat-menu-item (click)="delete(row)" class="menu_report"><mat-icon style="color: white;">delete</mat-icon> {{ 'onboardingUsers.table.menu.delete' | translate }}</button>
                      }
                    </mat-menu>
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              </mat-table>
              <mat-paginator showFirstLastButtons
                [length]="tableService.pager.totalEntities"
                [pageIndex]="tableService.pager.pageIndex"
                [pageSize]="tableService.pager.pageSize"
                [pageSizeOptions]="[10, 20, 50, 100]"
                (page)="list($event)">
              </mat-paginator>
            </div>
          </div>
          <div class="options-buttons">
            <button class="back-btn" (click)="goBack()">{{ 'onboardingUsers.buttons.back' | translate }}</button>
          </div>
        </div>
      </body>
